var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        "close-on-click-modal": false,
        "append-to-body": "",
        title: "选择位置",
        width: "500px",
      },
      on: { close: _vm.close },
    },
    [
      _c(
        "flexbox",
        { attrs: { align: "stretch" } },
        [
          _c(
            "flexbox-item",
            [
              _c("div", { staticClass: "area-title" }, [_vm._v("定位")]),
              _vm._v(" "),
              _c("el-autocomplete", {
                staticStyle: { width: "100%" },
                attrs: {
                  "fetch-suggestions": _vm.querySearchAsync,
                  placeholder: "请输入详细位置名称",
                },
                on: {
                  blur: _vm.inputBlur,
                  focus: _vm.inputFocus,
                  select: _vm.handleSelect,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ item }) {
                      return [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(item.address + item.title)),
                        ]),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.searchInput,
                  callback: function ($$v) {
                    _vm.searchInput = $$v
                  },
                  expression: "searchInput",
                },
              }),
              _vm._v(" "),
              _c("div", { ref: "myMap", staticClass: "map" }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.close } }, [_vm._v("取 消")]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.selectSure } },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }